import { render, staticRenderFns } from "./CompanyEvents.vue?vue&type=template&id=4e01eef8&"
import script from "./CompanyEvents.vue?vue&type=script&lang=js&"
export * from "./CompanyEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports